var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 17,
    width: 82,
    height: 106
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 17.5C57.1396 17.5 46.6667 27.9529 46.6667 40.8472V52.5H31.1667C30.0621 52.5 29.1667 53.3954 29.1667 54.5V120.5C29.1667 121.605 30.0621 122.5 31.1667 122.5H108.833C109.938 122.5 110.833 121.605 110.833 120.5V54.5C110.833 53.3954 109.938 52.5 108.833 52.5H93.3333V40.8472C93.3333 27.9523 82.8866 17.5 70 17.5ZM81.6667 64.1667H93.3333H99.1667V110.833H40.8333V64.1667H46.6667H58.3333H81.6667ZM81.6667 52.5V40.8472C81.6667 34.3943 76.442 29.1667 70 29.1667C63.5733 29.1667 58.3333 34.4057 58.3333 40.8472V52.5H81.6667ZM81.6667 87.5C81.6667 93.9433 76.4433 99.1667 70 99.1667C63.5567 99.1667 58.3333 93.9433 58.3333 87.5C58.3333 81.0567 63.5567 75.8333 70 75.8333C76.4433 75.8333 81.6667 81.0567 81.6667 87.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 140H140V0H0V140Z",
    fill: "#C1C7D0"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lock.71e352ee.svg";
export { ForwardRef as ReactComponent };